/* eslint-disable react/prop-types */
import { useState } from "react";
import { Drawer, Menu } from "antd";
import "./Sidebar.scss";
import { Button } from "antd";
import Sider from "antd/es/layout/Sider";
import { Link, useNavigate } from "react-router-dom";
import {
  AppstoreOutlined,
  DashboardOutlined,
  DollarOutlined,
  FileTextOutlined,
  SettingOutlined,
  TeamOutlined,
  TrophyOutlined,
} from "@ant-design/icons";
import { effectiveUserType } from "../../../utils/roles";
import { APP_BRAND_MARK, APP_BRAND_TAIL } from "../../../utils/brand";

const rootSubmenuKeys = ["1", "2", "3", "4", "5", "6", "7"];

const Sidebar = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  const [openKeys, setOpenKeys] = useState(["1"]);
  const [hoveredItem, setHoveredItem] = useState(null);

  props.collll(collapsed);

  const nav = useNavigate();

  const userType = effectiveUserType();
  const ps = localStorage.getItem("ps");

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const uType = userType;
  const hasRole = (roles) => roles.includes(userType);

  const hostName = window.location.hostname;

  return (
    <>
      <Sider
        trigger={null}
        width="280"
        collapsible
        collapsed={collapsed}
        className={`side_bar coll desk_side`}
          style={{
          background: "#ffffff",
        }}>
        <div className={collapsed ? "logo_icon" : "logo_icon coll_btn"}>
          <Button
            type="text"
            className="clolapsedd"
            icon={
              collapsed ? (
                <i className="gx-icon-btn icon icon-menu-fold" />
              ) : (
                <i className="gx-icon-btn icon icon-menu-unfold" />
              )
            }
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              width: 36,
              height: 36,
              border: "unset",
              textDecoration: "none",
              outline: "unset",
              color: "#0f172a",
            }}
          />
          <div
            onClick={() => nav("/dashboard")}
            className={`bm_side_logo ${collapsed ? "d-none" : ""}`}>
            <div className="bm_logo_mark" aria-hidden="true">
              {APP_BRAND_MARK}
            </div>
            <div className="bm_brand">
              <div className="bm_brand_title">{APP_BRAND_TAIL}</div>
              <div className="bm_brand_sub">Admin Dashboard</div>
            </div>
          </div>
        </div>
        <Menu
          style={{
            height: "calc(100vh - 70px)",
            minHeight: "calc(100vh - 70px)",
            maxHeight: "calc(100vh - 70px)",
            overflowY: "auto",
          }}
          theme=""
          mode="inline"
          openKeys={openKeys}
          onOpenChange={onOpenChange}
          defaultSelectedKeys={openKeys}
          items={[
            {
              key: "1",
              icon: <DashboardOutlined />,
              label: (
                <Link
                  to="/dashboard"
                  onClick={() => setOpenKeys([])}>
                  Dashboard
                </Link>
              ),
              // onClick:{handleDashBoard}
            },
            {
              key: "2",
              icon: <TeamOutlined />,
              label: (
                <div
                  onMouseEnter={() => setHoveredItem("2")}
                  onMouseLeave={() => setHoveredItem(null)}>
                  {uType == 6
                    ? "Admin Details"
                    : uType == 5
                    ? "Mini Admin Master"
                    : uType == 4
                    ? "Master Master"
                    : uType == 3
                    ? "Super Agent Master"
                    : userType == 7
                    ? "SuperAdmin"
                    : userType == 2
                    ? "Agent Master"
                    : ""}
                </div>
              ),
              children: [
                {
                  className: `${userType != "7" ? "d-none" : ""}`,
                  label: <Link to="/user-list/Admin/6">Admin</Link>,
                },
                {
                  className: hasRole(["7", "6"]) ? "" : "d-none",
                  label: (
                    <Link to="/user-list/Mini-Admin/5">Mini Admin Master</Link>
                  ),
                },
                {
                  className: hasRole(["7", "6", "5"]) ? "" : "d-none",
                  label: (
                    <Link to="/user-list/Master-Master/4">Master Master</Link>
                  ),
                },
                {
                  className: hasRole(["7", "6", "5", "4"]) ? "" : "d-none",
                  label: (
                    <Link to="/user-list/Super-Master/3">Super Master</Link>
                  ),
                },
                {
                  className: hasRole(["7", "6", "5", "4", "3"]) ? "" : "d-none",
                  label: (
                    <Link to="/user-list/Agent-Master/2">Agent Master</Link>
                  ),
                },
                {
                  label: (
                    <Link to="/user-list/Client-Master/1">Client Master</Link>
                  ),
                },
                {
                  className: `${userType === "7" ? "" : "d-none"}`,
                  label: <Link to="/create-domain">Create Domain</Link>,
                },
              ],
            },
            {
              key: "3",
              icon: <TrophyOutlined />,
              label: (
                <sapn
                  onMouseEnter={() => setHoveredItem("3")}
                  onMouseLeave={() => setHoveredItem(null)}>
                  Sports-Betting
                </sapn>
              ),
              children: [
                {
                  label: <Link to="/Events/sports-details">Active Games</Link>,
                },
                {
                  label: <Link to="/finish-game">Finished Games</Link>,
                },
                {
                  className: `${
                    userType === "7" || ps == "dtl" ? "" : "d-none"
                  }`,
                  label: <Link to="/delete-bet">Reject Bets</Link>,
                },
              ],
            },
            {
              key: "13",
              icon: <AppstoreOutlined />,
              label: (
                <div
                  onMouseEnter={() => setHoveredItem("4")}
                  onMouseLeave={() => setHoveredItem(null)}>
                  Casino
                </div>
              ),
              children: [
                {
                  label: <Link to="/inplay-casino">Inplay Casino</Link>,
                },
                {
                  label: <Link to="/completed-casino">Completed Casino</Link>,
                },
                {
                  label: <Link to="/casinoprofitandloss">Casino Details</Link>,
                },
              ],
            },
            {
              key: "4",
              icon: <FileTextOutlined />,
              label: (
                <div
                  onMouseEnter={() => setHoveredItem("5")}
                  onMouseLeave={() => setHoveredItem(null)}>
                  Ledger
                </div>
              ),
              children: [
                {
                  label: <Link to="/Events/matchledger">Profit/Loss</Link>,
                },
                {
                  label: <Link to="/client/my-ledger">My Leger</Link>,
                },
                {
                  className: `${userType != "7" ? "d-none" : ""}`,
                  label: (
                    <Link to="/client/ledger-super/6/Admin">Admin Leger</Link>
                  ),
                },
                {
                  className: hasRole(["7", "6"]) ? "" : "d-none",
                  label: (
                    <Link to="/client/ledger-super/5/Mini-Admin">
                      Mini Admin Leger
                    </Link>
                  ),
                },
                {
                  className: hasRole(["7", "6", "5"]) ? "" : "d-none",
                  label: (
                    <Link to="/client/ledger-super/4/Master">Master Leger</Link>
                  ),
                },
                {
                  className: hasRole(["7", "6", "5", "4"]) ? "" : "d-none",
                  label: (
                    <Link to="/client/ledger-super/3/Super">
                      Super agent Leger
                    </Link>
                  ),
                },
                {
                  className: hasRole(["7", "6", "5", "4", "3"]) ? "" : "d-none",
                  label: (
                    <Link to="/client/ledger-super/2/Agent">Agent Leger</Link>
                  ),
                },
                {
                  label: (
                    <Link to="/client/ledger-super/1/Client">Client Leger</Link>
                  ),
                },
              ],
            },
            userType === "7" && {
              key: "bet-settle",
              icon: <TrophyOutlined />,
              label: <Link to="/bet-settlement">Bet Settlement</Link>,
            },

            userType === "7" && {
              key: "pay-admin",
              icon: <DollarOutlined />,
              label: <Link to="/payment-admin">Deposit / Withdraw</Link>,
            },

            userType === "7" && {
              key: "15",
              icon: <FileTextOutlined />,
              label: (
                <div
                  onMouseEnter={() => setHoveredItem("16")}
                  onMouseLeave={() => setHoveredItem(null)}>
                  Post Ledger
                </div>
              ),
              children: [
                {
                  label: <Link to="/create-ledger">Create Ledger</Link>,
                },
                {
                  label: <Link to="/rollback">Rollback</Link>,
                },
              ],
            },

            userType === "7" && {
              key: "25",
              icon: <SettingOutlined />,
              label: (
                <div
                  onMouseEnter={() => setHoveredItem("26")}
                  onMouseLeave={() => setHoveredItem(null)}>
                  Event Controller
                </div>
              ),
              children: [
                {
                  label: <Link to="/event-lock">Event Lock</Link>,
                },
                {
                  label: (
                    <Link to="/completd-actibe-bet">
                      Complete Match Active Bet
                    </Link>
                  ),
                },
                {
                  label: <Link to="/delete-bets">Delete Bet</Link>,
                },
              ],
            },

            {
              key: "5",
              icon: <DollarOutlined />,
              label: (
                <div
                  onMouseEnter={() => setHoveredItem("6")}
                  onMouseLeave={() => setHoveredItem(null)}>
                  Cash Transaction
                </div>
              ),
              children: [
                {
                  label: (
                    <Link to="/client/txn-super/Client-Master/1">
                      (C) Debit/Credit Entry
                    </Link>
                  ),
                },
                // {
                //   // className: `${userType == "5" ? "" : "d-none"}`,
                //   label: (
                //     <Link to="/client/txn-super/Master/4">
                //       (M) Debit/Credit Entry
                //     </Link>
                //   ),
                // },
                {
                  className: hasRole(["7", "6", "5", "4", "3"]) ? "" : "d-none",
                  label: (
                    <Link to="/client/txn-super/Agent-Master/2">
                      (A) Debit/Credit Entry
                    </Link>
                  ),
                },
                {
                  className: hasRole(["7", "6", "5", "4"]) ? "" : "d-none",
                  label: (
                    <Link to="/client/txn-super/Super-Master/3">
                      (SA) Debit/Credit Entry
                    </Link>
                  ),
                },
                {
                  className: hasRole(["7", "6", "5"]) ? "" : "d-none",
                  label: (
                    <Link to="/client/txn-super/Master-Master/4">
                      (MA) Debit/Credit Entry
                    </Link>
                  ),
                },
                {
                  className: hasRole(["7", "6"]) ? "" : "d-none",
                  label: (
                    <Link to="/client/txn-super/Mini-Admin/5">
                      (AD) Debit/Credit Entry
                    </Link>
                  ),
                },
                {
                  className: `${userType === "7" ? "" : "d-none"}`,
                  label: (
                    <Link to="/client/txn-super/Admin/6">
                      (ADM) Debit/Credit Entry
                    </Link>
                  ),
                },
              ],
            },
            {
              className: `${userType === "7" ? "" : "d-none"}`,
              key: "28",
              icon: <SettingOutlined />,
              label: (
                <Link
                  onMouseEnter={() => setHoveredItem("28")}
                  onMouseLeave={() => setHoveredItem(null)}
                  to="/set-message">
                  Set Message
                </Link>
              ),
            },
            {
              key: "8",
              icon: <FileTextOutlined />,
              label: (
                <Link
                  onMouseEnter={() => setHoveredItem("7")}
                  onMouseLeave={() => setHoveredItem(null)}
                  to="/commissionLenden">
                  Comm. Report
                </Link>
              ),
            },
            {
              key: "6",
              icon: <FileTextOutlined />,
              label: (
                <div
                  onMouseEnter={() => setHoveredItem("8")}
                  onMouseLeave={() => setHoveredItem(null)}>
                  Reports
                </div>
              ),
              children: [
                {
                  label: <Link to="/client/login-report">Login Report</Link>,
                },
                {
                  label: (
                    <Link to="/client/secure-code">Secure Code Report</Link>
                  ),
                },
              ],
            },
            {
              key: "8",
              icon: <SettingOutlined />,
              label: (
                <Link
                  onMouseEnter={() => setHoveredItem("9")}
                  onMouseLeave={() => setHoveredItem(null)}
                  to="/markets">
                  {window?.location.hostname?.split(".")?.[1]?.toUpperCase()}{" "}
                  Setting
                </Link>
              ),
            },
            {
              key: "200",
              icon: <TeamOutlined />,
              label: (
                <div
                  onMouseEnter={() => setHoveredItem("200")}
                  onMouseLeave={() => setHoveredItem(null)}>
                  {uType == 6
                    ? "Dead Admin Details"
                    : uType == 5
                    ? "Dead Mini Admin Master"
                    : uType == 4
                    ? "Dead Master Master"
                    : uType == 3
                    ? "Dead Super Agent Master"
                    : userType == 7
                    ? "Dead SuperAdmin"
                    : userType == 2
                    ? "Dead Agent Master"
                    : ""}
                </div>
              ),
              children: [
                {
                  className: `${userType != "7" ? "d-none" : ""}`,
                  label: <Link to="/dead-user-list/Admin/6">Dead Admin</Link>,
                },
                {
                  className: hasRole(["7", "6"]) ? "" : "d-none",
                  label: (
                    <Link to="/dead-user-list/Mini-Admin/5">
                      Dead Mini Admin Master
                    </Link>
                  ),
                },
                {
                  className: hasRole(["7", "6", "5"]) ? "" : "d-none",
                  label: (
                    <Link to="/dead-user-list/Master-Master/4">
                      Dead Master Master
                    </Link>
                  ),
                },
                {
                  className: hasRole(["7", "6", "5", "4"]) ? "" : "d-none",
                  label: (
                    <Link to="/dead-user-list/Super-Master/3">
                      Dead Super Master
                    </Link>
                  ),
                },
                {
                  className: hasRole(["7", "6", "5", "4", "3"]) ? "" : "d-none",
                  label: (
                    <Link to="/dead-user-list/Agent-Master/2">
                      Dead Agent Master
                    </Link>
                  ),
                },
                {
                  label: (
                    <Link to="/dead-user-list/Client-Master/1">
                      Dead Client Master
                    </Link>
                  ),
                },
              ],
            },
          ]}
        />
      </Sider>

      <div className="mob_side">
        <Drawer
          title={
            <div className="bm_drawer_brand" onClick={props.action}>
              <span className="bm_logo_mark">{APP_BRAND_MARK}</span>
              <span className="bm_brand_title">{APP_BRAND_TAIL}</span>
            </div>
          }
          className="drawer_main"
          placement="left"
          closable={false}
          onClose={props.action}
          open={props.open}
          width={260}
          // key={placement}
        >
          <Menu
            theme=""
            mode="inline"
            openKeys={openKeys}
            onOpenChange={onOpenChange}
            defaultSelectedKeys={openKeys}
            items={[
              {
                key: "1",
                icon: <DashboardOutlined />,
                label: (
                  <Link
                    to="/dashboard"
                    onClick={() => {
                      props?.action();
                      setOpenKeys([]);
                    }}>
                    Dashboard
                  </Link>
                ),
              },
              {
                key: "2",
                icon: <TeamOutlined />,
                label: (
                  <div
                    onMouseEnter={() => setHoveredItem("2")}
                    onMouseLeave={() => setHoveredItem(null)}>
                    {uType == 6
                      ? " Admin Details"
                      : uType == 5
                      ? "Sub Detail"
                      : uType == 4
                      ? "Master Detail"
                      : uType == 3
                      ? "Super Detail"
                      : userType == 7
                      ? "Super Admin"
                      : "Agent Detail"}
                  </div>
                ),
                children: [
                  {
                    className: `${userType != "7" ? "d-none" : ""}`,
                    label: (
                      <Link
                        to="/user-list/Admin/6"
                        onClick={() => props?.action()}>
                        Admin
                      </Link>
                    ),
                  },
                  {
                    className: hasRole(["7", "6"]) ? "" : "d-none",
                    label: (
                      <Link
                        to="/user-list/Mini-Admin/5"
                        onClick={() => props?.action()}>
                        Mini Admin
                      </Link>
                    ),
                  },
                  {
                    className: hasRole(["7", "6", "5"]) ? "" : "d-none",
                    label: (
                      <Link
                        to="/user-list/Master-Master/4"
                        onClick={() => props?.action()}>
                        Master Master
                      </Link>
                    ),
                  },
                  {
                    className: hasRole(["7", "6", "5", "4"]) ? "" : "d-none",
                    label: (
                      <Link
                        to="/user-list/Super-Master/3"
                        onClick={() => props?.action()}>
                        Super Agent Master
                      </Link>
                    ),
                  },
                  {
                    className: hasRole(["7", "6", "5", "4", "3"])
                      ? ""
                      : "d-none",
                    label: (
                      <Link
                        to="/user-list/Agent-Master/2"
                        onClick={() => props?.action()}>
                        Agent Master
                      </Link>
                    ),
                  },
                  {
                    label: (
                      <Link
                        to="/user-list/Client/1"
                        onClick={() => props?.action()}>
                        Client Master
                      </Link>
                    ),
                  },
                  {
                    className: `${userType === "7" ? "" : "d-none"}`,
                    label: (
                      <Link onClick={() => props?.action()} to="/create-domain">
                        Create Domain
                      </Link>
                    ),
                  },
                ],
              },
              {
                key: "3",
                icon: <TrophyOutlined />,
                label: (
                  <sapn
                    onMouseEnter={() => setHoveredItem("3")}
                    onMouseLeave={() => setHoveredItem(null)}>
                    Sports-Betting
                  </sapn>
                ),
                children: [
                  {
                    label: (
                      <Link
                        to="/Events/sports-details"
                        onClick={() => props?.action()}>
                        Active Games
                      </Link>
                    ),
                  },
                  {
                    label: (
                      <Link to="/finish-game" onClick={() => props?.action()}>
                        Finished Games
                      </Link>
                    ),
                  },
                  {
                    className: `${
                      userType === "7" || ps == "dtl" ? "" : "d-none"
                    }`,
                    label: (
                      <Link to="/delete-bet" onClick={() => props?.action()}>
                        Reject Bets
                      </Link>
                    ),
                  },
                ],
              },
              {
                key: "13",
                icon: <AppstoreOutlined />,
                label: (
                  <div
                    onMouseEnter={() => setHoveredItem("4")}
                    onMouseLeave={() => setHoveredItem(null)}>
                    Casino
                  </div>
                ),
                children: [
                  {
                    label: (
                      <Link to="/inplay-casino" onClick={() => props?.action()}>
                        Inplay Casino
                      </Link>
                    ),
                  },
                  {
                    label: (
                      <Link
                        to="/completed-casino"
                        onClick={() => props?.action()}>
                        Completed Casino
                      </Link>
                    ),
                  },
                  {
                    label: (
                      <Link
                        to="/casinoprofitandloss"
                        onClick={() => props?.action()}>
                        Casino Details
                      </Link>
                    ),
                  },
                ],
              },
              {
                key: "4",
                icon: <FileTextOutlined />,
                label: (
                  <div
                    onMouseEnter={() => setHoveredItem("5")}
                    onMouseLeave={() => setHoveredItem(null)}>
                    Ledger
                  </div>
                ),
                children: [
                  {
                    label: (
                      <Link
                        onClick={() => props?.action()}
                        to="/Events/matchledger">
                        Profit/Loss
                      </Link>
                    ),
                  },
                  {
                    label: (
                      <Link
                        onClick={() => props?.action()}
                        to="/client/my-ledger">
                        My Ledger
                      </Link>
                    ),
                  },
                  {
                    className: `${userType != "7" ? "d-none" : ""}`,
                    label: (
                      <Link
                        onClick={() => props?.action()}
                        to="/client/ledger-super/6/Admin">
                        Admin Leger
                      </Link>
                    ),
                  },
                  {
                    className: hasRole(["7", "6"]) ? "" : "d-none",
                    label: (
                      <Link
                        onClick={() => props?.action()}
                        to="/client/ledger-super/5/Mini-Admin">
                        Mini Admin Leger
                      </Link>
                    ),
                  },
                  {
                    className: hasRole(["7", "6", "5"]) ? "" : "d-none",
                    label: (
                      <Link
                        onClick={() => props?.action()}
                        to="/client/ledger-super/4/Master">
                        Master Leger
                      </Link>
                    ),
                  },
                  {
                    className: hasRole(["7", "6", "5", "4"]) ? "" : "d-none",
                    label: (
                      <Link
                        onClick={() => props?.action()}
                        to="/client/ledger-super/3/Super-Agent">
                        Super agent Leger
                      </Link>
                    ),
                  },
                  {
                    className: hasRole(["7", "6", "5", "4", "3"])
                      ? ""
                      : "d-none",
                    label: (
                      <Link
                        onClick={() => props?.action()}
                        to="/client/ledger-super/2/Agent">
                        Agent Leger
                      </Link>
                    ),
                  },
                  {
                    label: (
                      <Link
                        onClick={() => props?.action()}
                        to="/client/ledger-super/1/Client">
                        Client Leger
                      </Link>
                    ),
                  },
                ],
              },
              userType === "7" && {
                key: "pay-admin-m",
                icon: <DollarOutlined />,
                label: (
                  <Link onClick={() => props?.action()} to="/payment-admin">
                    Deposit / Withdraw
                  </Link>
                ),
              },
              userType === "7" && {
                key: "15",
                icon: <FileTextOutlined />,
                label: (
                  <div
                    onMouseEnter={() => setHoveredItem("16")}
                    onMouseLeave={() => setHoveredItem(null)}>
                    Post Ledger
                  </div>
                ),
                children: [
                  {
                    label: (
                      <Link onClick={() => props?.action()} to="/create-ledger">
                        Create Ledger
                      </Link>
                    ),
                  },
                  {
                    label: (
                      <Link onClick={() => props?.action()} to="/rollback">
                        Rollback
                      </Link>
                    ),
                  },
                ],
              },
              userType === "7" && {
                key: "25",
                icon: <SettingOutlined />,
                label: (
                  <div
                    onMouseEnter={() => setHoveredItem("26")}
                    onMouseLeave={() => setHoveredItem(null)}>
                    Event Controller
                  </div>
                ),
                children: [
                  {
                    label: (
                      <Link onClick={() => props?.action()} to="/event-lock">
                        Event Lock
                      </Link>
                    ),
                  },
                  {
                    label: (
                      <Link
                        onClick={() => props?.action()}
                        to="/completd-actibe-bet">
                        Complete Match Active Bet
                      </Link>
                    ),
                  },
                  {
                    label: (
                      <Link onClick={() => props?.action()} to="/delete-bets">
                        Delete Bet
                      </Link>
                    ),
                  },
                ],
              },
              {
                key: "5",
                icon: <DollarOutlined />,
                label: (
                  <div
                    onMouseEnter={() => setHoveredItem("6")}
                    onMouseLeave={() => setHoveredItem(null)}>
                    Cash Transaction
                  </div>
                ),
                children: [
                  {
                    label: (
                      <Link
                        to="/client/txn-super/Client-Master/1"
                        onClick={() => props?.action()}>
                        (C) Debit/Credit Entry
                      </Link>
                    ),
                  },
                  // {
                  //   // className: `${userType == "5" ? "" : "d-none"}`,
                  //   label: (
                  //     <Link to="/client/txn-super/Master/4">
                  //       (M) Debit/Credit Entry
                  //     </Link>
                  //   ),
                  // },
                  {
                    className: hasRole(["7", "6", "5", "4", "3"])
                      ? ""
                      : "d-none",
                    label: (
                      <Link
                        to="/client/txn-super/Agent-Master/2"
                        onClick={() => props?.action()}>
                        (A) Debit/Credit Entry
                      </Link>
                    ),
                  },
                  {
                    className: hasRole(["7", "6", "5", "4"]) ? "" : "d-none",
                    label: (
                      <Link
                        to="/client/txn-super/Super-Master/3"
                        onClick={() => props?.action()}>
                        (SA) Debit/Credit Entry
                      </Link>
                    ),
                  },
                  {
                    className: hasRole(["7", "6", "5"]) ? "" : "d-none",
                    label: (
                      <Link
                        to="/client/txn-super/Master-Master/4"
                        onClick={() => props?.action()}>
                        (MA) Debit/Credit Entry
                      </Link>
                    ),
                  },
                  {
                    className: hasRole(["7", "6"]) ? "" : "d-none",
                    label: (
                      <Link
                        to="/client/txn-super/Mini-Admin/5"
                        onClick={() => props?.action()}>
                        (AD) Debit/Credit Entry
                      </Link>
                    ),
                  },
                  {
                    className: `${userType === "7" ? "" : "d-none"}`,

                    label: (
                      <Link
                        to="/client/txn-super/Admin/6"
                        onClick={() => props?.action()}>
                        (ADM) Debit/Credit Entry
                      </Link>
                    ),
                  },
                ],
              },
              {
                className: `${userType === "7" ? "" : "d-none"}`,
                key: "28",
                icon: <SettingOutlined />,
                label: (
                  <Link
                    onClick={() => props?.action()}
                    onMouseEnter={() => setHoveredItem("28")}
                    onMouseLeave={() => setHoveredItem(null)}
                    to="/set-message">
                    Set Message
                  </Link>
                ),
              },
              {
                key: "18",
                icon: <FileTextOutlined />,
                label: (
                  <Link
                    onClick={() => props?.action()}
                    onMouseEnter={() => setHoveredItem("7")}
                    onMouseLeave={() => setHoveredItem(null)}
                    to="/commissionLenden">
                    Comm. Report
                  </Link>
                ),
              },
              {
                key: "6",
                className: "data_report_list",
                icon: <FileTextOutlined />,
                label: (
                  <div
                    onMouseEnter={() => setHoveredItem("8")}
                    onMouseLeave={() => setHoveredItem(null)}>
                    Reports
                  </div>
                ),
                children: [
                  {
                    key: "14",
                    label: (
                      <Link
                        to="/client/login-report"
                        onClick={() => props?.action()}>
                        Login Report
                      </Link>
                    ),
                  },
                  {
                    key: "14",
                    label: (
                      <Link
                        to="/client/secure-code"
                        onClick={() => props?.action()}>
                        Secure Code Report
                      </Link>
                    ),
                  },
                ],
              },
              {
                key: "7",
                icon: <SettingOutlined />,
                label: (
                  <Link
                    onMouseEnter={() => setHoveredItem("9")}
                    onMouseLeave={() => setHoveredItem(null)}
                    to="/markets"
                    onClick={() => {
                      props?.action();
                      setOpenKeys([]);
                    }}>
                    {window?.location.hostname?.split(".")[1]?.toUpperCase()}{" "}
                    Setting
                  </Link>
                ),
              },

              {
                key: "200",
                icon: <TeamOutlined />,
                label: (
                  <div
                    onMouseEnter={() => setHoveredItem("200")}
                    onMouseLeave={() => setHoveredItem(null)}>
                    {uType == 6
                      ? "Dead Admin Details"
                      : uType == 5
                      ? "Dead Mini Admin Master"
                      : uType == 4
                      ? "Dead Master Master"
                      : uType == 3
                      ? "Dead Super Agent Master"
                      : userType == 7
                      ? "Dead SuperAdmin"
                      : userType == 2
                      ? "Dead Agent Master"
                      : ""}
                  </div>
                ),
                children: [
                  {
                    className: `${userType != "7" ? "d-none" : ""}`,
                    label: (
                      <Link
                        onClick={() => props?.action()}
                        to="/dead-user-list/Admin/6">
                        Dead Admin
                      </Link>
                    ),
                  },
                  {
                    className: hasRole(["7", "6"]) ? "" : "d-none",
                    label: (
                      <Link
                        onClick={() => props?.action()}
                        to="/dead-user-list/Mini-Admin/5">
                        Dead Mini Admin Master
                      </Link>
                    ),
                  },
                  {
                    className: hasRole(["7", "6", "5"]) ? "" : "d-none",
                    label: (
                      <Link
                        onClick={() => props?.action()}
                        to="/dead-user-list/Master-Master/4">
                        Dead Master Master
                      </Link>
                    ),
                  },
                  {
                    className: hasRole(["7", "6", "5", "4"]) ? "" : "d-none",
                    label: (
                      <Link
                        onClick={() => props?.action()}
                        to="/dead-user-list/Super-Master/3">
                        Dead Super Master
                      </Link>
                    ),
                  },
                  {
                    className: hasRole(["7", "6", "5", "4", "3"])
                      ? ""
                      : "d-none",
                    label: (
                      <Link
                        onClick={() => props?.action()}
                        to="/dead-user-list/Agent-Master/2">
                        Dead Agent Master
                      </Link>
                    ),
                  },
                  {
                    label: (
                      <Link
                        onClick={() => props?.action()}
                        to="/dead-user-list/Client-Master/1">
                        Dead Client Master
                      </Link>
                    ),
                  },
                ],
              },
            ]}
          />
        </Drawer>
      </div>
    </>
  );
};

export default Sidebar;
